import { IncidentsCreateRedirect } from '../../pages/incidents/IncidentsCreateRedirect';

const EditTransport = async () =>
    import('../../pages/transports/Edit').then((module) => ({
        Component: module.EditTransport,
    }));

const LogisticManagementTransportsList = async () =>
    import('../../pages/transports/List').then((module) => ({
        Component: module.LogisticManagementTransportsList,
    }));

const ListForCarriers = async () =>
    import('../../pages/transports/ListForCarriers').then((module) => ({
        Component: module.ListForCarriers,
    }));

const LogisticManagementNewTransport = async () =>
    import('../../pages/transports/New').then((module) => ({
        Component: module.LogisticManagementNewTransport,
    }));

const LogisticManagementTransportView = async () =>
    import('../../pages/transports/View').then((module) => ({
        Component: module.LogisticManagementTransportView,
    }));

const ToursList = async () =>
    import('../../pages/tours/List').then((module) => ({
        Component: module.ToursList,
    }));

const TourView = async () =>
    import('../../pages/tours/View').then((module) => ({
        Component: module.TourView,
    }));

// Only LSP routes
const NewTransportInit = async () =>
    import('../../pages/transports/Init').then((module) => ({
        Component: module.NewTransportInit,
    }));

const IncidentsList = async () =>
    import('../../pages/incidents/list/List').then((module) => ({
        Component: module.IncidentsList,
    }));

const UnconfirmedTransportsList = async () =>
    import('../../pages/unconfirmed-transports/List').then((module) => ({
        Component: module.UnconfirmedTransportsList,
    }));
const UnconfirmedTransportView = async () =>
    import('../../pages/unconfirmed-transports/View').then((module) => ({
        Component: module.UnconfirmedTransportView,
    }));

const getTransportsRoutes = (user) => {
    const transportRoutes =
        user?.customer?.settings?.tour_management_enabled || // SHIPPER
        user?.logisticProvider?.settings?.tour_management_enabled // LSP
            ? [
                  // Tours (transport tours)
                  {
                      path: '/tours/',
                      lazy: ToursList,
                  },
                  {
                      path: '/tours/view/:viewId',
                      lazy: ToursList,
                  },
                  {
                      path: '/tours/:tourId/',
                      lazy: TourView,
                  },
              ]
            : [];

    if (user?.carrierId) {
        transportRoutes.push(
            //  Transports
            {
                path: '/transports/',
                lazy: ListForCarriers,
            }
        );
    }
    if (user?.isTransportOrdersManagementEnabled || user.carrierId) {
        transportRoutes.push(
            //  Transports
            {
                path: '/transports/',
                lazy: LogisticManagementTransportsList,
            },
            {
                path: '/transports/new',
                lazy: LogisticManagementNewTransport,
            },

            {
                path: '/transports/:orderId/',
                lazy: LogisticManagementTransportView,
            },
            // Not used, not tested for now, to be removed or reworked in a future issue
            {
                path: '/transports/:orderId/edit',
                lazy: EditTransport,
            },

            // Incidents List
            {
                path: '/incidents/create',
                element: <IncidentsCreateRedirect />,
            },
            {
                path: '/incidents/',
                lazy: IncidentsList,
            },
            {
                path: '/incidents/view/:viewId',
                lazy: IncidentsList,
            }
        );
    }

    if (user.role === 'PROVIDER' && user?.isTransportOrdersManagementEnabled) {
        transportRoutes.push(
            //  Transports
            {
                path: '/transports/init',
                lazy: NewTransportInit,
                conditionFailedRedirect: '/',
            },
            // Unconfirmed transports
            {
                path: '/unconfirmed-transports/',
                lazy: UnconfirmedTransportsList,
            },
            {
                path: '/unconfirmed-transports/:transportId/',
                lazy: UnconfirmedTransportView,
            }
        );
    }

    return transportRoutes;
};

export { getTransportsRoutes };
